import type { RouteRecordRaw } from 'vue-router'
import LoginPage from '@/pages/auth/LoginPage.vue'

export const AuthPages = {
  login: 'Login',
}

export const Login: RouteRecordRaw = {
  path: '/',
  name: AuthPages.login,
  component: LoginPage,
  meta: { title: 'Auth', requiresAuth: false },
}
